import { useState } from "react";
import * as UIComponents from "@ucchub/ui";
import { useTranslation } from "react-i18next";
import { CommercialCriteria } from "@components/customer/CommercialCriteria.types";
import { Country } from "@components/country/Country.types";
import useAddEditBillingContext from "@hooks/billingContext/useAddEditBillingContext";
import BillingContextConfigForm from "./AddBillingContextForm";
import AddBillingContextSuccessModel from "./AddBillingContextSuccessModel";
import { AddBillingContextFormValues } from "@components/customer/BillingContext.types";
import { ServiceType } from "@components/CommercialCriteria/ServiceType.types";
import { BillingContextListResponseV1 } from "@ucchub/ui/src/apiTypes/cloudNumbers";

interface AddBillingContextModalProps {
  isOpen: boolean;
  customerId: string;
  onClose: () => void;
  commercialCriteria: CommercialCriteria[];
  billingContextList: BillingContextListResponseV1[];
  countryList: Country[];
  accessTypeList: ServiceType[];
  refreshData: () => void;
  commercialId: string;
}

const AddBillingContextModal = (props: AddBillingContextModalProps) => {
  const { t } = useTranslation();

  const { submitAddBillingContext, error, setError, billingContextName } =
    useAddEditBillingContext();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successModalModalOpen, setSuccessModalModalOpen] = useState(false);

  const closeModal = () => {
    props.onClose();
    setError(undefined);
  };

  const handleOnSubmit = (data: AddBillingContextFormValues) => {
    const { isCheckboxChecked, ...formData } = data;
    if (!isCheckboxChecked) return;

    setIsSubmitting(true);
    submitAddBillingContext({ orgId: props.customerId, ...formData })
      .then(() => {
        setIsSubmitting(false);
        setSuccessModalModalOpen(true);
        closeModal();
      })
      .catch(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <UIComponents.Modal
        srName="AddCommercialCriteriaModal"
        isOpen={props.isOpen}
        isClosable
        size={5}
        animate
        onClose={closeModal}
      >
        <BillingContextConfigForm
          onSubmit={handleOnSubmit}
          onCancel={closeModal}
          isSubmitting={isSubmitting}
          error={error}
          commercialCriteria={props.commercialCriteria}
          countryList={props.countryList}
          accessTypeList={props.accessTypeList}
          commercialId={props.commercialId}
          billingContextList={props.billingContextList}
        />
      </UIComponents.Modal>
      <AddBillingContextSuccessModel
        isOpen={successModalModalOpen}
        body={"'" + billingContextName + "' added."}
        heading={t("core:billingContext:add:success_message")}
        confirmText={t("core:accountConfig:okay")}
        onClose={() => {
          setSuccessModalModalOpen(false);
          props.refreshData();
        }}
      />
    </>
  );
};

export default AddBillingContextModal;
